import React, { Component } from "react"

import { 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@material-ui/core"

import api from "../../api.js"

import ErrorMessageDialog from "../../ui/ErrorMessageDialog.js"
import CodeNotFoundDialog from "./CreateDialog/CodeNotFoundDialog.js"

// import SelectDewarPanel from "./CreateDialog/SelectDewarPanel"
import SelectUserPanel from "./CreateDialog/SelectUserPanel"

import SelectUserDialog from "../../users/SelectUserDialog.js"
// import SelectDewarDialog from "../../dewars/SelectDewarDialog.js"

/**
 * События элемента
 * 
 * @param props.onCreateClick(user, dewar, comment) - запрос на добавление сосуда Дьюара.
 * @param props.onCancelClick() - запрос отмены.
 */

class CreateDialog extends (Component) {

    constructor(props) {
        
        super(props)
        
        this.state = {
            dialog: undefined,
            user: undefined,
            code: "",
            comment: "",
        }

    }

	handle_error = (error) => {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {() => {
					this.update()
						.then(() => {this.setState({dialog: undefined})})
						.catch(this.handle_error)
				}}
			/>
		})
	}      

    /**
     * Поверка ввода.
     * 
     * Условия:
     * - все поля должны быть заполнены.
     */

    isReady() {
        // if (!this.state.dewar) {
        //     return false
        // }
        if (!this.state.code) {
            return false
        }
        if (!this.state.user) {
            return false
        }
        return true
    }

    render() {

        if (this.state.dialog) {
            return this.state.dialog
        }

        return <Dialog
            open = {true}
            fullWidth = {true}        
        >

            <DialogTitle>Добавить сосуд Дьюара</DialogTitle>

            <DialogContent style = {{display: "flex", flexDirection: "column", gap: "10px"}}>

                {/* <SelectDewarPanel 
                    selected={this.state.dewar}
                    onSelectButtonClick={() => {
                        this.setState({dialog: <SelectDewarDialog 
                            onSelect={(dewar) => {
                                this.setState({
                                    dewar: dewar,
                                    dialog: undefined,
                                })
                            }}
                            onCancel={()=>{
                                this.setState({dialog: undefined})
                            }}
                        />})
                    }}
                />*/}

                <SelectUserPanel 
                    selected={this.state.user}
                    onSelectButtonClick={() => {
                        this.setState({dialog: <SelectUserDialog 
                            onSelectUser={async (user)=>{
                                this.setState({
                                    user: user,
                                    dialog: undefined,
                                })
                            }}
                            onCancel={()=>{
                                this.setState({dialog: undefined})
                            }}
                        />})
                    }}
                />

                <TextField 
                    variant="outlined"
                    label="Код сосуда Дьюара."
                    value={this.state.code}
                    onChange={(e) => {
                        e.stopPropagation()
                        this.setState({code: e.target.value})
                    }}
                />

                <TextField 
                    variant="outlined"
                    label="Комментарий"
                    value={this.state.comment}
                    onChange={(e) => {
                        e.stopPropagation()
                        this.setState({comment: e.target.value})
                    }}
                />
                
            </DialogContent>

            <DialogActions>

                <Button
                    disabled = {!this.isReady()}
                    onClick = {async (e) => {
                        try {
                            e.stopPropagation()
                            let response = await api.dewars.find(this.state.code)
                            if (String(response.id) === "0") {
                                this.setState({dialog: <CodeNotFoundDialog 
                                    code={this.state.code}
                                    onCloseClick={() => {
                                        this.setState({dialog: undefined})
                                    }}
                                />})
                            } else {
                                if (typeof this.props.onCreateClick === "function") {
                                    this.props.onCreateClick(response.id, this.state.user.id, this.state.comment)
                                }
                            }
                        }
                        catch(e) {
                            this.handle_error(e)
                        }
                    }}
                >Добавить</Button>

                <Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancelClick === "function") {
							this.props.onCancelClick()
						}
					}}
				>Отмена</Button>

            </DialogActions>

        </Dialog>

    }

}

export default CreateDialog